export const ProviderEn = () => {
    return (
        <>
            <h1>Provider</h1>
            <ul>
                <li>Daimler Truck AG</li>
                <li>Fasanenweg 10</li>
                <li>70771 Leinfelden-Echterdingen</li>
                <li>Germany</li>
                <li>Tel.: +49 711 8485-0</li>
                <li>Email: <a href='mailto:contact@daimlertruck.com' className='wb-link wb-link--inline'>contact@daimlertruck.com</a></li>
            </ul>

            <h1>Represented by the Board of Management:</h1>
            <p>Karin Rådström (Chairwoman), Yvonne Bettkober, Andreas Gorbach, Jürgen Hartwig, John O‘Leary, Achim Puchert, Eva Scherer</p>

            <h1>Chairman of the Supervisory Board:</h1>
            <p>Joe Kaeser</p>
            <ul>
                <li>Commercial Register Stuttgart, No. HRB 762884</li>
                <li>VAT registration number: DE 32 12 81 771</li>
            </ul>
        </>
    );
};